import React from 'react'
import Text from '../components/Text'

export default ({ children }) => (
  <Text large primary fw={600}>{children}</Text>
)
